export default __webpack_public_path__ + "static/media/DominateTheRoad.775a3217.JPG";